<template lang='pug'>
//- 課程播放器
div(:class='$style[`cc-popbox-course-player`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(v-if='preloading' :class='[$style[`cc-popbox-course-player-wrap`], $style[`cc-popbox-course-player-wrap-flex`]]')
    div(:class='$style[`cc-content-course-loading`]')
      IconLoading( :size='60' :color='`#b1b1b1`')

  div(v-else :class='$style[`cc-popbox-course-player-wrap`]')
    div(v-if='needSubscribe' :class='$style[`cc-content-course-result`]')
      div(:class='$style[`cc-popbox-course-player-tutorial`]')
        div(:class='$style[`cc-popbox-course-player-tutorial-wrap`]')
          span.font-bold 本單元為VIP會員限定<br>請先訂閱
          figure(:class='$style[`cc-popbox-course-player-tutorial-graphic`]')
            img(:src='`${STATIC_URL}images/subscribe/expire.webp`' width='100%')

    div(v-else :class='$style[`cc-content-course-result`]')
      div(v-if='unitContent' :class='$style[`cc-content-course-audio`]')
        header.font-medium.no-wrap(:class='$style[`cc-content-course-audio-unit`]') 單元 {{ unitContent.chapter_sort / 10 }}-{{ unitContent.sort / 10 }}  | {{ unitContent.title }}
        AudioPlayer(
          :key='`audio-${nextTicket}`'
          :file='unitContent.media_url'
          :nextUnit='unitContent.next_unit_id'
          @switchNext='forceSwitchNextUnit'
          @resetAudio='forceResetAudioPlayer')

      .prevent-selection(
        @click.right.prevent
        @keydown.prevent
        @copy.prevent
        @paste.prevent
        :class='$style[`cc-content-course-result-content`]' )
        //- header.font-medium {{ unitContent.title }}
        //- article.font-light {{ unitContent.content }}
        v-md-preview(:text='unitContent.content')

    div(v-if='needSubscribe' :class='$style[`cc-content-course-control`]')
      button.btn-extra(
        title='升級VIP會員'
        tabindex='0' aria-label='升級VIP會員'
        :class='$style[`cc-content-course-control-btn`]'
        @click='handleClickRedirectSubscribe') 立即訂閱

      button.btn-black-extra(
        title='關閉'
        tabindex='0' aria-label='關閉'
        :class='$style[`cc-content-course-control-btn`]'
        @click='handleClosePopBox')
        span 關閉

    div(v-else :class='$style[`cc-content-course-control`]')
      button.btn-extra(
        v-if='unitContent.prev_unit_id'
        title='上一單元'
        tabindex='0' aria-label='上一單元'
        :class='[$style[`cc-content-course-control-btn`], $style[`cc-content-course-control-prev`]]'
        @click='handleClickSwitchUnit(unitContent.prev_unit_id)') 
        span ← 上一單元

      button.btn-extra(
        v-if='unitContent.next_unit_id'
        title='下一單元'
        tabindex='0' aria-label='下一單元'
        :class='[$style[`cc-content-course-control-btn`], $style[`cc-content-course-control-next`]]'
        @click='handleClickSwitchUnit(unitContent.next_unit_id)') 
        span 下一單元 →

      button.btn-black-extra(
        title='關閉'
        tabindex='0' aria-label='關閉'
        :class='$style[`cc-content-course-control-btn`]'
        @click='handleClosePopBox')
        span 關閉

</template>

<script>
// import axios from 'axios';
import { mapMutations, mapGetters } from 'vuex';
import Inputer from '../common/Input';
import IconLoading from '../../icon/Loading';
import AudioPlayer from '../common/AudioPlayer';

import {
  putLoadCourseUnitContent,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    IconLoading,
    AudioPlayer,
  },

  props: {
    cid: Number,
    uid: Number,
  },

  data() {
    return {
      preloading: true,
      needSubscribe: true,
      audioBlob: null,
      unitContent: {},
      nextTicket: 1,
    };
  },

  created() {
    this.axiosLoadCourseUnitContent(this.cid, this.uid);
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopCourseStatus: 'global/POPCOURSE_STATUS',
    }),

    handleClosePopBox() {
      this.changePopCourseStatus({
        active: false,
        cid: '',
        uid: '',
      });
    },

    axiosLoadCourseUnitContent(cid, uid) {
      this.preloading = true;
      this.unitContent = {};

      putLoadCourseUnitContent('', {
        course_id: `${cid}`,
        unit_id: `${uid}`,
      })
        .then((res) => {
          this.unitContent = res.data;
          this.needSubscribe = false;
          this.preloading = false;
        })
        .catch((err) => {
          // console.log('Detect Subscribe!!!', err.response.data);
          this.preloading = false;

          if (err.response.data === 'need subscribe') {
            this.needSubscribe = true;
          } else if (err.response.data === 'not found') {
            this.$router.push({
              name: 'error404',
            }).catch(() => true);
          }
        });

      // this.nextTick += 1;
      // console.log('Check 4', this.audioActive);
      // this.audioActive = true;
    },

    handleClickRedirectSubscribe() {
      // this.audioActive = false;
      this.handleClosePopBox();
      this.$router.push('/shop/subscribe').catch(() => true);
    },

    handleClickSwitchUnit(openUnitId) {
      this.axiosLoadCourseUnitContent(this.cid, openUnitId);
    },

    forceSwitchNextUnit(openUnitId) {
      this.axiosLoadCourseUnitContent(this.cid, openUnitId);
    },

    forceResetAudioPlayer() {
      console.log('forceResetAudioPlayer');
      this.nextTicket += 1;
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      loginDjangoId: 'user/exportUserDjangoId',
      loginStatus: 'user/exportLoginStatus',
      // loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popCoursePlayer.scss';
</style>
